import * as React from 'react'
import {useEffect} from 'react'
import {authenticator} from '../../app/auth/SessionPlusAuthenticator'
import {arPathOverview} from '../../ar/store/ar.paths'

const getArfbrRedirectUri = () => {
  const schema = window.location.protocol
  const domain = window.location.hostname
  const port = window.location.port
  return `${schema}//${domain}${port ? ':' + port : ''}` + arPathOverview()
}

export const DigitalArfbrLoginPage = () => {
  useEffect(() => {
    const redirectUri = getArfbrRedirectUri()
    if (authenticator.isAuthenticated()) {
      window.location.href = redirectUri
    } else {
      authenticator.login(undefined, redirectUri)
    }
  }, [])

  return <div />
}
